import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { connect } from 'react-redux'
import { CSVLink, CSVDownload } from 'react-csv';
import { Button } from 'react-materialize'


class CountryResourcesTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      allData_CSV: [],
      allData: [],
      selectedData: {},
      tableLength: 10
    };
  }

  componentWillMount(){
    var allData_CSV = [["Country", "Type", "Risk Factor", "Year", "Title", "Authors", "Journal/Publisher", "Volumn/Pages", "Description", "URL"]]
    this.props.allData.forEach( data => {
        allData_CSV.push([ data.country, data.type, data.risk_factor, data.year, data.title, data.authors, data.journal_publisher, data.volumn_pages, data.description, data.url ])
    })
    var selectedData = []
    var rthis = this
    this.props.allData.forEach( document => {
      if( this.props.countries.includes(document.country)){
        selectedData.push(document);
      }
    })
    this.setState({ 
      allData_CSV: allData_CSV,
      countries: this.props.countries,
      selectedData
      })
  }


  render() {

    const { allData_CSV, allData, countries, selectedData, tableLength } = this.state;
    const columns = [
          {
            Header: 'Country',
            accessor: 'country',
            headerClassName: 'table-left-header',
            width: 100,
            className: 'table-left-header' // String-based value accessors!
          },
          {
            Header: 'Type',
            accessor: 'type',
            headerClassName: 'table-left-header',
            className: 'table-left-header',
            width: 70,
            style:{ 'white-space': 'unset'} // String-based value accessors!
           },
           {
            Header: 'Risk Factor',
            accessor: 'risk_factor',
            headerClassName: 'table-left-header',
            className: 'table-left-header',
            width: 100,
            style:{ 'white-space': 'unset'} // String-based value accessors!
           },
           {
             Header: 'Year',
             accessor: 'year',
             headerClassName: 'table-left-header',
             width: 70,
             className: 'table-left-header' // String-based value accessors!
            },
            {
              Header: 'Title',
              accessor: 'title',
              headerClassName: 'table-left-header',
              className: 'table-left-header',
              width: 'auto',
              style:{ 'white-space': 'unset'} // String-based value accessors!
            },
            {
              Header: 'Authors',
              accessor: 'authors',
              headerClassName: 'table-left-header',
              className: 'table-left-header',
              width: 'auto',
              style:{ 'white-space': 'unset'} // String-based value accessors!
            },
            {
              Header: 'Journal/Publisher',
              accessor: 'journal_publisher',
              headerClassName: 'table-left-header',
              className: 'table-left-header',
              style:{ 'white-space': 'unset'},
              width: 200 // String-based value accessors!
            },
            {
              Header: 'Volumn/Pages',
              accessor: 'volumn_pages',
              headerClassName: 'table-left-header',
              className: 'table-left-header',
              style:{ 'white-space': 'unset'},
              width: 120 // String-based value accessors!
            },
            {
              expander: true,
              Header: () => 'Description',
              headerClassName: 'table-left-header',
              className: 'table-left-header',
              style:{ 
                'white-space': 'unset',
                cursor: "pointer",
                fontSize: 25,
                padding: "0",
                textAlign: "center",
                userSelect: "none"
                },
              width: 150, // String-based value accessors!
              Expander: ({ isExpanded, ...rest }) =>
              <div>
                {isExpanded ? <span>&#x2299;</span> : <span>&#x2295;</span>}
              </div>
            },
            {
              Header: 'URL',
              accessor: 'url',
              Cell: e =><a href={e.value}  target="_blank"> {e.value} </a>,
              headerClassName: 'table-left-header',
              className: 'table-left-header',
              style:{ 'white-space': 'unset'},
              width: 150 // String-based value accessors!
            }]
            
  /* showPagination={false}
  defaultPageSize={table_data.length} */
  var csv = [["Country", "Type", "Risk Factor", "Year", "Title", "Authors", "Journal/Publisher", "Volumn/Pages", "Description", "URL"]]

  if(selectedData){
    selectedData.forEach( data => {
      csv.push([ data.country, data.type, data.risk_factor, data.year, data.title, data.authors, data.journal_publisher, data.volumn_pages, data.description, data.url ])
    })
  }
  return (
    <div className="table">
      <ReactTable
        className="-striped -highlight"
        data={selectedData}
        columns={columns}
        showPagination={false}
        defaultPageSize={selectedData.length}
        style={{
            height: "590px"
          }}
        defaultSorted={[
           {
             id: "country",
             desc: false
           }
         ]}
         SubComponent={row => {
          return (
            <div style={{ padding: "20px" }}>
                {row.original.description}
            </div>
            );
          }}
      />
      <br/>
      <div className="pulled-right">
        <Button><CSVLink style={{color: "white"}} data={csv} >Download CSV</CSVLink></Button>
        &nbsp;&nbsp;&nbsp;
        <Button><CSVLink style={{color: "white"}} data={allData_CSV} >Download all Data</CSVLink></Button>
      </div>
    </div>
  )}
}


export default CountryResourcesTable;



// WEBPACK FOOTER //
// ./src/components/CountryResourcesTable.js